// extracted by mini-css-extract-plugin
export var csatScore = "_l3-5";
export var header = "_l3-1";
export var panelWrapper = "_l3-2";
export var postPreview = "_l3-3";
export var rightContent = "_l3-0";
export var wrappingText = "_l3-4";